import styled from 'styled-components'

export const AppliedFilters = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;
  max-width: 1068px;
  padding: 16px;

  @media (min-width: 992px) {
    padding: 24px 0 0 0;
  }
`

export const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  white-space: nowrap;
  gap: 8px;
  overflow-x: auto;
`

export const FilterTag = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: 26px;
  padding: 5px 10px 5px 10px;
  gap: 5px;
  border-radius: 50px;
  border: 1px solid ${({ theme }) => theme.colors.coolGray.cool400};
  background: ${({ theme }) => theme.colors.grayscale.white};
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.06px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`

export const RemoveFilterButton = styled.button`
  border: none;
  background: transparent;
  margin: 0;
  padding: 0;
  height: 16px;
  cursor: pointer;
`

export const RemoveFilterIcon = styled.img`
  width: 16px;
  height: 16px;
`

export const RemoveAllFiltersButton = styled.button`
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.brand.blue};
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 16.41px;
  letter-spacing: 0.06em;
  text-align: left;
  text-transform: uppercase;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  cursor: pointer;
  white-space: nowrap;
`
